import { useState, useEffect, useRef, useLayoutEffect} from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Toaster, toast } from 'react-hot-toast';
import { GETALLPRODUCTS, GETCATEGORIESLIST, GETCATEGORYFIELDS, GETCAMPAIGN, ADDCAMPAIGN, UPDATECAMPAIGN, GETCOMPARISONLIST, DOWNLOADCOMPARISONDATA, GETPRICECOMPARISONDATA } from "../../api/apiConfig";
import { apiGet, apiPost } from "../../utils/services";
import axios from "axios";
import { Button, FormControlLabel, Grid, Paper, Radio, RadioGroup, Stack, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Tooltip, Popover,  Dialog, DialogTitle, Snackbar,  DialogContent, useMediaQuery} from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { Title, Spinner } from "../../components/atoms";
import { useCallback } from "react";
import AllRoundLogo from "../../assets/images/allround.png"
import TalentLogo from "../../assets/images/tallentlogo.png"
import RomidaLogo from "../../assets/images/romidaLogo.png"
import MrCricketLogo from "../../assets/images/mrCricketLogo.png"
import OzwatLogo from "../../assets/images/ozwatLogo.png"
import TCSLogo from "../../assets/images/Tcs_price_logo.png"
import MorantLogo from "../../assets/images/morant_logo.png"
import SeriousLogo from "../../assets/images/serious_logo.png"
import CricketHockeyLogo from "../../assets/images/cricketHocky_logo.png"
import topDealIcon from "../../assets/images/topDeal-Icon.svg";
import Select from "react-select";
import { useQuery } from "react-query";
import { getProductModels, getUserIntegrations } from "../../api/api";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import { FaInfoCircle, FaTimesCircle } from "react-icons/fa";
import Popup from "../../components/atoms/Popup/Popup";
import { Modal as ReactModal } from "react-responsive-modal";
import { AnalyticsService } from "../../utils/Analytics";
import { BiLoaderCircle, BiCheckCircle, BiDownload } from "react-icons/bi";
import  MarketingRow  from './marketingList.js';
import ConfirmTopDealPrices from './ConfirmTopDealProducts.js';
import { Link } from 'react-router-dom';
//import {KeyboardArrowDownIcon, KeyboardArrowUpIcon} from "@mui/icons-material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { CustomScroll } from "react-custom-scroll";
import { type } from "@testing-library/user-event/dist/type/index.js";


const  Marketing = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState();
    const [popup, setPopup] = useState({})
    const [comparison, setComparison] = useState([]);
    const [topProducts, setTopProducts] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [topDealProducts, setTopDealProducts] = useState([]);
    const [newState, setNewState] = useState("");
    const [isFirstView, setISFirstView] = useState(false);    
    const [isError, setIsError] = useState(false);
    const [approveTopProducts, setApproveTopProducts] = useState(false);
    const [isComparisonLoading, setIsComparisonLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isTopDealPreview, setIsTopDealPreview] = useState(false);
    const [productRowFocusDetails, setProductRowFucosDetails] = useState(undefined);
    const [isPriceSync, setIsPriceSync] = useState(false);
    const [state, setState] = useState({
        productCategories: [],
        
    });

    const [open, setOpen] = useState(false);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const priceCompTableRef = useRef();
    const priceCompRowRef = useRef([]);

    const onOpenModal = () => setOpen(true);
    const onCloseModal = () => setOpen(false);
    
    const openPopup = (name, e) => {
        setPopup({ ...popup, [name]: popup[name] ? null : e.currentTarget })
    }
    const closePopup = () => {
        setPopup({})
    }
    const updateState = (data) => setState((prevState) => ({ ...prevState, ...data }));
    const updateTopDealProducts = (data) => setTopDealProducts(data);

    useEffect( () => {

   
        const fetchData = async() =>{
        if(prodCategories.length === 0 || productCategories === null || productCategories === undefined)
        {        
          await  getProductCategories();
        }
       // await getProducts();
       
       if(campaign === null || campaign === undefined)
       {
        await getCampaign();
       }
        
      
        await getPriceComparisonData();
        
        }
        
        fetchData();

        
    }, []);
    

    const {
        productCategories,
        selectedCategory,
        selectedModel,
        startDate,
        endDate,
        campaign,
        isCheckedRadio,
        discount,  
        selectedFilterCategory,
        selectedFilterModel,
        priceComparisonData,
        tablePriceComparisonData,
       
    } = state;


    const prodCategories =
        productCategories &&
        productCategories.map((m) => ({
            value: m.id,
            label: m.name,
        }));
    const DisplaySpinner = () => {

            return (
              <div className="spinnerDiv">
                <Spinner color={"black"} loading={true} size={40} />
              </div>
            );
          };

        useEffect( () => {
            if(discount === "Best Price")
            {
                const catId =  selectedCategory?.value;
                const modelId = selectedModel?.value;
          
    
                if(catId === null 
                    || catId === undefined 
                    || modelId === null 
                    || modelId === undefined 
                    || priceComparisonData === undefined 
                    || priceComparisonData === null) return;
                
                const filterObj = JSON.parse(JSON.stringify(priceComparisonData));
                const products = filterObj.filter(prod => prod.categoryId === catId && prod.modelId === modelId);
                if(products === null || products === undefined || products.length === 0) return;
    
                const hasAnyLowestPrice = products.some(product => product.isLowestPrice === true);
                if(hasAnyLowestPrice)
                {
                    setShowPopup(true);
                }
            }
               
        }, [discount, isCheckedRadio]);

        useEffect(() => {
         
            if(productRowFocusDetails === undefined) return;

            if(tablePriceComparisonData != undefined)
            {
          
                if(tablePriceComparisonData.length > 0)
                {
                  
                    setIsLoaded(!isLoaded);
                }
            }
            
        }, [productRowFocusDetails]);

        useEffect(() => {
            
           
            const focusRow = () => {
              
                if(productRowFocusDetails === undefined) return;

                const idToFocus = productRowFocusDetails.productId;//8686922629458;//
                
                
                const indexToFocus = tablePriceComparisonData.findIndex(row => row.productId === idToFocus);
                
                
               
                if (indexToFocus !== -1 && priceCompRowRef.current[indexToFocus]) {
                   

                    priceCompRowRef.current[indexToFocus].focus();
                }
            };
           
            if (tablePriceComparisonData && tablePriceComparisonData.length > 0) {
               
                focusRow();
            }

            setProductRowFucosDetails(undefined);
            
        }, [isLoaded]);
        

        const selectStyle = {
            fontWeight: 'normal', 
          };
    const getProductCategories = async () => {
        setIsLoading(true);
        const res = await apiGet(GETCATEGORIESLIST);
        if (res) {
            const { data } = res;
            updateState({ productCategories: data});
        }
        setIsLoading(false);
    };
  const getPriceComparisonData = async () => {
    setIsComparisonLoading(true);
   try
   {
    const res = await apiPost(GETPRICECOMPARISONDATA);
        if(res)
        {
            const {data} = res;
            var tableData = JSON.parse(JSON.stringify(data));
            updateState({priceComparisonData: [...data], tablePriceComparisonData: [...tableData]});
           
        }
    const response = await getUserIntegrations();
        
    if(response){
        if(response.isShopifyIntegrated && response.isShopifyPriceSync){
            setIsPriceSync(true);
        }
    }
        
   }
   catch(error)
   {
    
   }
      
   setIsComparisonLoading(false);
  }
  const handlePopupClose = () => {
    setShowPopup(false); 
};
    const getCampaign = async () => {
        setIsLoading(true);
        const res = await apiGet(GETCAMPAIGN);
        
        if (res) {
            const { data } = res;
            updateState({ campaign: data });
            
        }
        setIsLoading(false);
    };

    const setSelectedProductModel = (option) => {
        updateState({ selectedModel: option , isCheckedRadio:false});
    };

    const currentCategory = selectedCategory?.label
        ? selectedCategory
        : prodCategories[0];

    const {
        isLoading: isProductModelsLoading,
        data: { data: productModels } = { data: [] },
    } = useQuery(
        ["models", selectedCategory?.value],
        () => getProductModels(currentCategory.value),
        {
            enabled: currentCategory != null,
        }
    );

    const getProducts = useCallback(async () => {
        setIsLoading(true);
        const res = await apiPost(GETALLPRODUCTS, { vendor: "The Cricket Store" });
        if (res) {

            setData(res);
            
        }
        setIsLoading(false);
    }, [setData, setIsLoading]);

   const handleComparisonCategoryChange = (option) => {
    setIsLoading(true);
    
    const filterRef = [...priceComparisonData];
    var filteredComparisonData = filterRef.filter(prod=> prod.categoryId == option.value);
    var filtered = JSON.parse(JSON.stringify(filteredComparisonData));
    updateState({tablePriceComparisonData: [...filtered], selectedFilterCategory: option});
    setIsLoading(false);
    
   };
   const handleComparisonModelChange = (option) => {
    setIsLoading(true);
    
    let dataToFilter = [...priceComparisonData];
    var filteredComparisonData = dataToFilter.filter(prod=> prod.modelId == option.value);
      var filtered = JSON.parse(JSON.stringify(filteredComparisonData));
    updateState({tablePriceComparisonData: [...filtered], selectedFilterModel:option, selectedModel:{}});
    setIsLoading(false);
    
   };
    const setSelectedCategory = (option) => {
        
        updateState({ selectedCategory: option, selectedModel: null, selectedGrade: null, isCheckedRadio: false });
        const { value } = option;
        if (value !== 0) {
            getFieldHeadingsAndValues(value);
        }
    };
    
    
    const getRetailPriceArray = (product) => {
        let competitorPriceArray = [];

        if(product.cricketHockey != "" )
        {
           
            competitorPriceArray.push(parseFloat(product.cricketHockey.replace(/[^0-9.]/g, '')));
        }
        if(product.talentCricket != "")
        {
            competitorPriceArray.push(parseFloat(product.talentCricket.replace(/[^0-9.]/g, '')));
        }
        if(product.ozwat != "")
        {
            competitorPriceArray.push(parseFloat(product.ozwat.replace(/[^0-9.]/g, '')));
        }
        if(product.allRoundCricket != "")
        {
            competitorPriceArray.push(parseFloat(product.allRoundCricket.replace(/[^0-9.]/g, '')));
        }
        if(product.romida != "")
        {
            competitorPriceArray.push(parseFloat(product.romida.replace(/[^0-9.]/g, '')));
        }
        if(product.mrCricket != "")
        {
            competitorPriceArray.push(parseFloat(product.mrCricket.replace(/[^0-9.]/g, '')));
        }
        if(product.morant != "")
        {
            competitorPriceArray.push(parseFloat(product.morant.replace(/[^0-9.]/g, '')));
        }
        if(product.serious != "")
        {
            competitorPriceArray.push(parseFloat(product.serious.replace(/[^0-9.]/g, '')));
        }
      

        return competitorPriceArray;
       
    }
    const handleOnClickComparisonProduct = (productId) => {
      
        if(productId === null || productId === undefined) return;
        let products = [];
        
        let percentageReduction = 0;
        const newFilterRef = JSON.parse(JSON.stringify(priceComparisonData));
        const product = newFilterRef.filter(prod => prod.productId === productId)[0];
       
        let competitorPriceArray = getRetailPriceArray(product);        
        let minRetailPrice = Math.min(...competitorPriceArray);
         
        let isTopPreview = false;
        setIsTopDealPreview(isTopPreview);

        let topPreviewDates = undefined;

        
        if(product.isLowestPrice && !product.isTopDeal) 
        {
            product.percentageDiscount = 0;
            product.proposedPrice = parseFloat(product.currentPrice.replace(/[^0-9.]/g, ''));
            product.variants.forEach(variant => {
                
                    variant.proposedPrice = variant.price;
                    variant.percentageDiscount = 0;
                    variant.isLowestPrice = true;
                    if(competitorPriceArray.length > 0)
                    {
                        variant.isLowestPrice = variant.proposedPrice < minRetailPrice;
                    }
                    
                
                
              });
        }
        else if(!product.isLowestPrice && !product.isTopDeal)
        {
        
        let minVariantPrice = parseFloat(product.currentPrice.replace(/[^0-9.]/g, ''));
       
    
        let proposedMinVariantPrice  = minRetailPrice - 1;
    
        percentageReduction = ((minVariantPrice - proposedMinVariantPrice) / minVariantPrice) * 100;
        
        product.percentageDiscount = percentageReduction.toFixed(2);
        product.proposedPrice = proposedMinVariantPrice;
    
        product.variants.forEach(variant => {
            if(variant.price != minVariantPrice)
            {
                let amountToReduce = percentageReduction/100 * variant.price;
                variant.proposedPrice = variant.price - amountToReduce;
                variant.percentageDiscount = percentageReduction.toFixed(2);
                if(variant.proposedPrice > minRetailPrice)
                        {
                            variant.isLowestPrice = false;
                        }
                        else
                        {
                            variant.isLowestPrice = true;
                        }
            }
            else{
                variant.proposedPrice = proposedMinVariantPrice;
                variant.percentageDiscount = percentageReduction.toFixed(2);

                if(variant.proposedPrice > minRetailPrice)
                        {
                            variant.isLowestPrice = false;
                        }
                        else
                        {
                            variant.isLowestPrice = true;
                        }
            }
            
          });
    
    
        product.isLowestPrice = true;
        }
        else if(product.isLowestPrice && product.isTopDeal)
        {
           
            product.proposedPrice = parseFloat(product.currentPrice.replace(/[^0-9.]/g, ''));
            product.variants.forEach(variant => {
                
                    variant.proposedPrice = variant.price;
                    variant.price = variant.compareAtPrice;                    
                    variant.isLowestPrice = true;
                    if(competitorPriceArray.length > 0)
                    {
                        variant.isLowestPrice = variant.proposedPrice < minRetailPrice;
                    }
                    
                
                
              });
            percentageReduction = product.percentageDiscount;
            topPreviewDates = {start: new Date(product.topDealStart), end: new Date(product.topDealEnd)};
          
            isTopPreview = true;
              

        }
        else if(!product.isLowestPrice && product.isTopDeal)
        {
           
            product.proposedPrice = parseFloat(product.currentPrice.replace(/[^0-9.]/g, ''));
            product.variants.forEach(variant => {
                
                    variant.proposedPrice = variant.price;
                    variant.price = variant.compareAtPrice;                    
                    variant.isLowestPrice = true;
                    if(competitorPriceArray.length > 0)
                    {
                        variant.isLowestPrice = variant.proposedPrice < minRetailPrice;
                    }
                    
                
                
              });
            percentageReduction = product.percentageDiscount;
            topPreviewDates = {start: new Date(product.topDealStart), end: new Date(product.topDealEnd)};
            
            isTopPreview = true;
              

        }
        
        products.push(product);
       const topCopy = JSON.parse(JSON.stringify(products));
       
        setIsTopDealPreview(isTopPreview);
        setTopProducts([...topCopy]);
        setISFirstView(true);
        updateState({ discount: percentageReduction, selectedCategory: {}, selectedModel: {}, startDate:topPreviewDates?.start, endDate:topPreviewDates?.end });       
        setOpenConfirmModal(true);              
        
    }
    
    const getFieldHeadingsAndValues = async (categoryId) => {
        const res = await apiGet(`${GETCATEGORYFIELDS}/${categoryId}`);
        if (res) {
            const { data } = res;
            const options = data.map((m) => {
                return {
                    id: m.id,
                    heading: m.heading,
                    fieldValues: m.fieldValues.map((e) => ({
                        value: e.id,
                        label: e.value,
                    })),
                };
            });
            updateState({ fields: options });
        }
    };
    const getComparisonData = async (category) => {
    const res = await apiPost(GETCOMPARISONLIST, {category:category});
    if(res)
    {
      
        setComparison(res);
        
    }
    setIsLoading(false);
    };

    function isLowestPrice(d){
        return d?<BiCheckCircle size={"12px"} color="green"/>:<FaTimesCircle size={"12px"} color="red"/>
      }
    function minimixeProductName(name){
        if(name === undefined || name === null) return;
        if(name.length > 24) return name.substring(0, 24) + "....";

        return name;
    }
    function comparisonUpdateTime(){
       if(priceComparisonData === undefined || priceComparisonData === null) return "";
       
       if(priceComparisonData.length === 0) return "";

        
      return "Last Updated: " + priceComparisonData[0]?.updatedAt;
        
        
    }
    
    const handleTopProductUpdate = (products) =>{
      
            setTopProducts([...products]);
    }
    const handleOnClickAddCampaign = () => {
        
        setIsTopDealPreview(false);
        let products = [];
        

        const catId =  selectedCategory?.value;
        const modelId = selectedModel?.value;
      
        
        
        if(catId === null || catId === undefined || modelId === null || modelId === undefined) return;
        if(priceComparisonData === null || priceComparisonData === undefined) return;
        
        const filterObj = JSON.parse(JSON.stringify(priceComparisonData));
        const _products = filterObj.filter(prod => prod.categoryId === catId && prod.modelId === modelId);
      
      
        if(_products === null || _products === undefined || _products.length === 0) return;
    
        _products.forEach(product => {
            console.log("here 3");
    
         let competitorPriceArray = getRetailPriceArray(product);
         let _discount = 0;      
         let minRetailPrice  = Math.min(...competitorPriceArray);

         if(discount === "Best Price" && !product.isLowestPrice)
         {
            
            if(competitorPriceArray.length > 0)
            {            
                
                let minVariantPrice = parseFloat(product.currentPrice.replace(/[^0-9.]/g, ''));       
            
                let proposedMinVariantPrice  = minRetailPrice - 1;
                product.isLowestPrice = true;
                _discount = ((minVariantPrice - proposedMinVariantPrice) / minVariantPrice) * 100;
               
            }
            else{
                    _discount = 0;
                    product.isLowestPrice = true
                    
            }
         }
         else if(discount === "Best Price" && product.isLowestPrice)
         {
                _discount = 0;
                
         }    
         else{

            if(competitorPriceArray.length > 0)
            {                
                _discount = discount;
                if(product.proposedPrice > minRetailPrice)
                {
                    product.isLowestPrice = false;
                }
            }
            else
            {
                product.isLowestPrice = true;
                _discount = discount;
            }

            
         }    
        
        
        let amountToReduceFromProduct = (_discount/100 * parseFloat(product.currentPrice.replace(/[^0-9.]/g, ''))).toFixed(2);
        product.proposedPrice = (parseFloat(product.currentPrice.replace(/[^0-9.]/g, '')) - amountToReduceFromProduct).toFixed(2);
        product.percentageDiscount = _discount.toFixed(2);
        
   
       
        product.variants.forEach(variant => {
                 
                        let amountToReduce = _discount/100 * variant.price;
                        variant.proposedPrice = (variant.price - amountToReduce).toFixed(2);
                        variant.percentageDiscount = _discount.toFixed(2);
                 
                        if(variant.proposedPrice > minRetailPrice)
                        {
                            variant.isLowestPrice = false;
                        }
                        else
                        {
                            variant.isLowestPrice = true;
                        }
                    
         });
       
        products.push(product);
    });
    
        setTopProducts([...products]);   
        setISFirstView(false);    
        setOpenConfirmModal(true);
        updateState({discount:undefined});
        
    }
    const handleConfirmDealClose = async (refreshData, isSingleProduct, productId = null)=>{
       
        setOpenConfirmModal(false);
        if(isSingleProduct && !refreshData)
        {
            setProductRowFucosDetails({productId:productId});
        }
        else{
            setProductRowFucosDetails(undefined);
        }

        if(refreshData)
        {
            await getCampaign();
            
            await getPriceComparisonData();
            if(isSingleProduct) setProductRowFucosDetails({productId:productId});
        }
        
    }
    const handleRefreshData = async() => {
        
        await getPriceComparisonData();
    }
    return (
        <div className="tabPanelCls h-100" >
            <Toaster containerStyle={{ zIndex: 999999 }} />


            <div className="dispatchTimer" style={{ position: 'relative', textAlign: 'center' }}>
                <div style={{ width: '100%', background: 'white', marginTop: '10px' }}>
                    <div className="header">
                        <Stack direction={{xs: 'column', md: 'row'}} spacing={3}>
                            <h2>Create a Top Deal</h2>
                            <Button onClick={() => onOpenModal()} variant="contained">View Existing Deals</Button>
                        </Stack>
                    </div>
                    
                    <div className="mt-1 space-top">
                        <p className="sm  " style={{ width: '95%', textAlign: 'left' }}>
                            You must select the product Category & Model
                        </p>

                        <Paper className="padding2 space-top">
                            <Grid  container spacing={2}>
                                <Grid item md={3} xs={6} style={{ textAlign: 'left'}}>
                                    <div id="categorySelection">
                                        <Title text={"Category"} className="formLabelCls" />
                                        <Select 
                                            style={selectStyle}
                                            placeholder={"Please select"}
                                            onChange={(option) => setSelectedCategory(option)}
                                            options={prodCategories}
                                            value={selectedCategory}
                                            defaultValue={prodCategories ? prodCategories[0] : undefined}
                                            isSearchable={false}
                                        />
                                    </div>
                                </Grid>
                                <Grid item md={3} xs={6} style={{ textAlign: 'left'}}>
                                    <div id="categorySelection">
                                        <Title text={"Model"} className="formLabelCls" />
                                        <Select
                                            style={selectStyle}
                                            placeholder={"Please select"}
                                            onChange={(option) => setSelectedProductModel(option)}
                                            options={productModels.map((m) => ({
                                                value: m.id,
                                                label: m.name,
                                            }))}
                                            value={selectedModel}
                                            isSearchable={false}
                                        />
                                    </div>
                                </Grid>
                                <Grid item md={3} xs={6} style={{ textAlign: 'left' }}>
                                    <div id="categorySelection">
                                        <Title text={"Start Date"} className="formLabelCls" />
                                        <div style={{ marginTop: '8px' }}>
                                            <DatePicker
                                                placeholderText="Select Start Date"
                                                className="datepicker click"
                                                onChange={(date) => {
                                                    updateState({ startDate: date })
                                                }}
                                                selectsStart
                                                showMonthDropdown
                                                showYearDropdown
                                                value={startDate != null && moment(startDate).format('DD/MM/yyyy')}
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                selected={startDate}
                                                startDate={startDate}
                                                endDate={endDate}
                                                maxDate={endDate}
                                                style={{ width: '100%' }}
                                            />
                                        </div>

                                    </div>
                                </Grid>
                                <Grid item md={3} xs={6} style={{ textAlign: 'left' }}>
                                    <div id="categorySelection">
                                        <Title  text={"End Date"} className="formLabelCls" />
                                        <div style={{ marginTop: '8px' }}>
                                            <DatePicker
                                                placeholderText="Select End Date"
                                                className="datepicker click"
                                                onChange={(date) => {
                                                    updateState({ endDate: date })
                                                }}
                                                selectsStart
                                                showMonthDropdown
                                                showYearDropdown
                                                value={endDate != null && moment(endDate).format('DD/MM/yyyy')}
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                selected={endDate}
                                                startDate={startDate}
                                                endDate={endDate}
                                                minDate={startDate}
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <Stack direction={"row"} spacing={2} className="center space-top">
                                <Title text={"Discount"} className="formLabelCls" />
                                <FaInfoCircle color="red" className="click" onClick={(e) => openPopup('info', e)} />
                                <Popup target={popup.info} >
                                    <div className="center padding2 white" style={{ maxHeight: '300px', width: '300px', overflowY: 'auto', background: '#DE031E', borderRadius: '10px 10px 0px 0px' }}>
                                        <FaInfoCircle size={25} color="white" className="center3" style={{ width: '100%' }} />
                                        <div className="xl bold">Information</div>
                                        <div className="sm">This is a discount on the current price the item is listed on the store at. The price will revert to the current price following the expiry of the top deal campaign.</div>
                                    </div>
                                    <Button onClick={() => closePopup()}
                                        variant="contained" fullWidth sx={{ background: "white", color: "#DE031E" }}>Ok</Button>
                                </Popup>
                            </Stack>
       
                            <div >
                                <div className="mobileOnly space-bottom3">
                                    <Grid>
                                    <div id="categorySelection">
                                        <Title text={""} className="formLabelCls" />
                                        <Select 
                                            style={selectStyle}
                                            placeholder={"Please select percentage"}
                                            onChange={(option) => { updateState({ discount: option.value })}}
                                            options={["Best Price", 5, 10, 15, 20, 25, 30, 35, 40, 45, 50].map((m) => ({
                                                value: m,
                                                label: m +"%",
                                            }))}
                                            value={data?.value}
                                            defaultValue={5}
                                            isSearchable={false}
                                        />
                                    </div>
                                    </Grid>
                                </div>
                                <div className="desktopOnly">
                                    <RadioGroup
                                        aria-labelledby="demo-form-control-label-placement"
                                        name="position"
                                        size="small"
                                        defaultValue="top">
                                        <Grid container style={{overflowX:'auto'}}>
                                            {[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, "Best Price"].map((d, i) => {
                                                return (
                                                    <Grid item md={1} xs={3}>
                                                   
                                                        <FormControlLabel
                                                            size="small"
                                                            value={d}

                                                            control={<Radio checked={discount === d && isCheckedRadio}size="small" onClick={() => { updateState({ discount: d, isCheckedRadio:true })}} />}
                                                            label={d == "Best Price" ? d : d + "%"}
                                                            labelPlacement="bottom"
                                                            style={{ whiteSpace: 'nowrap' }}
                                                        />
                                                    {/* //</Tooltip> */}
                                                    </Grid>
                                                )
                                            })}
                                        </Grid>
                                   </RadioGroup>
                                </div>
                                {isLoading && (<div
                                style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(255, 255, 255, 0.8)', 
                                zIndex: 9999,
                                }}
                            >
                        <DisplaySpinner />
                        
                        </div>)}

                                <div className="push-right space-top2">
                                    <Stack direction={"row"} spacing={2}>
                                        <Button variant="contained" sx={{ background: "#4E9D24" }} onClick={() => handleOnClickAddCampaign()}>Launch Campaign</Button>
                                        {/* <Button variant="contained" sx={{ background: "#000" }}>Cancel</Button> */}
                                    </Stack>

                                </div>

                            </div>
                            <Popover
                                open={showPopup}
                                anchorEl={null}
                                onClose={handlePopupClose}
                                anchorOrigin={{
                                    vertical: 'center',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'center',
                                    horizontal: 'center',
                                }}
                            >
                                <div className="center padding2 white" style={{ maxHeight: '300px', width: '300px', overflowY: 'auto', background: '#DE031E', borderRadius: '10px 10px 0px 0px' }}>
                                This product(s) is already listed at the best price available.
                                </div>
                                
                                <Button onClick={() => handlePopupClose()}
                                        variant="contained" fullWidth sx={{ background: "white", color: "#DE031E" }}>Ok</Button>
                            </Popover>
                        </Paper>
                     {localStorage.getItem("roleId") === "1" && (<div className="space-bottom"><div className="space-top"  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <div style={{ flex: 1 }}>
                        <h2  style={{ margin: 0, textAlign: 'center', paddingRight: ''}}>Live Comparison </h2>
                        </div>
                        <span className="sm light desktopOnly" style={{ marginLeft: 'auto', paddingRight: '30px' }}>{comparisonUpdateTime()}</span>
                        </div>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={6} sm={4} md={3} style={{ textAlign: 'left'}}>
                                <div className="formLayer1" id="categorySelection">
                                    <Title text={"Category"} className="formLabelCls" />
                                    <Select
                                        placeholder={"Please select"}
                                        onChange={(option) => handleComparisonCategoryChange(option)}
                                        options={prodCategories}
                                        value={selectedFilterCategory}
                                        defaultValue={prodCategories ? prodCategories[0] : undefined}
                                        isSearchable={false}
                                        styles={{
                                            menu: base => ({
                                              ...base,
                                              zIndex: 9999 // Set a high z-index value to ensure it appears above the table sticky header below
                                            })
                                          }}
                                    />
                                </div>
                            </Grid>                           
                            
                            <Grid item md={3} xs={6} sm={4} style={{ textAlign: 'left'}}>
                                <div className="formLayer1" id="categorySelection">
                                    <Title text={"Model"} className="formLabelCls" />
                                    <Select
                                        placeholder={"Please select"}
                                        onChange={(option) => handleComparisonModelChange(option)}
                                        options={productModels.map((m) => ({
                                            value: m.id,
                                            label: m.name,
                                        }))}
                                        value={selectedFilterModel}
                                        isSearchable={false}
                                        styles={{
                                            menu: base => ({
                                              ...base,
                                              zIndex: 9999 // Set a high z-index value to ensure it appears above the table sticky header below
                                            })
                                          }}
                                    />
                                </div>
                            </Grid>

                            {localStorage.getItem("roleId") === "1" && 
                            (<Grid item xs={12} sm={6} md={6} container justifyContent="flex-end" >
                                <Button
                                   style={{marginTop: '30px'}}
                                    enabled={isDownloading}
                                    onClick={async () => {
                                        let userData = localStorage.getItem("access_token");
                                        const url = DOWNLOADCOMPARISONDATA;
                                        setIsDownloading(true);
                                        axios({
                                        url, 
                                        method: "GET",
                                        responseType: "blob",                                         headers: {
                                            authorization: `Bearer ${userData}`,
                                        },
                                        })
                                        .then((response) => {
                                            setIsDownloading(false);
                                            // create file link in browser's memory
                                            const href = URL.createObjectURL(response.data);
    
                                            // create "a" HTML element with href to file & click
                                            const link = document.createElement("a");
                                            link.href = href;
                                            link.setAttribute("download", "PriceComparison.csv"); //or any other extension
                                            document.body.appendChild(link);
                                            link.click();
    
                                            // clean up "a" element & remove ObjectURL
                                            document.body.removeChild(link);
                                            URL.revokeObjectURL(href);
                                        })
                                        .catch((e) => {
                                            setIsDownloading(false);
                                        });
                                    }}
                                    sx={{ background: "#F0F0F0", color: "black" }}
                                    startIcon={
                                        isDownloading ? (
                                        <BiLoaderCircle sx={{ color: "#8D0C18" }} />
                                        ) : (
                                        <BiDownload sx={{ color: "#8D0C18" }} />
                                        )
                                    }
                                    variant="contained"
                                    >
                                    Download Data
                                    </Button>
                                </Grid>)}
                        </Grid> 
                        {isComparisonLoading ? (<div className="space-top padding" style={{alignContent: 'center',  justifyContent: 'center', display: 'flex'}}><DisplaySpinner/></div>) :
                                (                
                        <Paper ref={priceCompTableRef} tabIndex={0} className="padding space-top" sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer  sx={{
                                                "&::-webkit-scrollbar": {
                                                width: 5,
                                                height: 5
                                                },
                                                "&::-webkit-scrollbar-track": {
                                                backgroundColor: "white"
                                                },
                                                "&::-webkit-scrollbar-thumb": {
                                                backgroundColor: "red",
                                                borderRadius: 3,
                                                
                                                },
                                                maxHeight: 440
                                            }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ position: 'sticky', left: 0, background: 'white', zIndex: 2,}} ><span className='sm'>Product Name</span></TableCell>
                                        <TableCell style={{textAlign: 'center', position: 'sticky', left: 225, background: 'white', zIndex: 2,}}><img src={TCSLogo} alt="Tcs logo" /></TableCell>                                        
                                        {/* <TableCell><span className='bold'>Cricket Direct</span></TableCell> */}
                                        {/* <TableCell><span className='bold'>ProDirect</span></TableCell> */}
                                        <TableCell style={{ textAlign: 'center', zIndex: 0}}><img src={TalentLogo} alt="Talent logo" /></TableCell>
                                        {/* <TableCell><span className='bold'>Serious Cricket</span></TableCell> */}
                                        <TableCell style={{textAlign: 'center', zIndex: 0}}><img src={OzwatLogo} alt="Ozwat logo" style={{ width: '100px', height: '25px' }}/></TableCell>
                                        {/* <TableCell><span className='bold'>Total Cricket</span></TableCell> */}
                                        <TableCell style={{textAlign: 'center', zIndex: 0}}><img src={AllRoundLogo} alt="all round logo" /></TableCell>
                                        <TableCell style={{textAlign: 'center', zIndex: 0}}><img src={RomidaLogo} alt="Romida logo" /></TableCell>
                                        <TableCell style={{textAlign: 'center', zIndex: 0}}><img src={MrCricketLogo} alt="Mr Cricket logo" /></TableCell>
                                        <TableCell style={{textAlign: 'center', zIndex: 0}}><img src={MorantLogo} alt="Morant logo" /></TableCell>
                                        <TableCell style={{textAlign: 'center', zIndex: 0}}><img src={SeriousLogo} alt="Serious logo" /></TableCell>
                                        <TableCell style={{textAlign: 'center', zIndex: 0}}><img src={CricketHockeyLogo} alt="Cricket Hockey logo" /></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                
                                    {tablePriceComparisonData?.map((data, index) => {
                                        
                                        return (
                                            
                                            <TableRow key={data.productId} ref={(ref) => {priceCompRowRef.current[index] = ref;} } tabIndex={0} style={{ maxHeight: '25px' }}>
                                                <TableCell  style={{position: 'sticky', left: 0, background: 'white', zIndex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', padding: '0px'}}>
                                                    <Tooltip title={data.productName}>
                                                        <span onClick={() => handleOnClickComparisonProduct(data.productId)} style={{ position: 'relative', display: 'inline-block', cursor: 'pointer',  paddingLeft: '28px'}}>
                                                        {minimixeProductName(data.productName)}
                                                    <span style={{}}>
                                                        {data.isTopDeal && (<img src={topDealIcon} style={{ width: '10px', height: '10px', position: 'absolute', top: 3, left: 0}} alt="icon" />)}
                                                    
                                                    </span>
                                                    <span style={{ position: 'absolute', top: 3, left: 13 }}>
                                                        {isLowestPrice(data.isLowestPrice)}
                                                        </span>
                                                    </span>
                                                    </Tooltip>
                                                </TableCell>
                                                 <TableCell style={{textAlign: 'center', position: 'sticky', left: 225, background: 'white', zIndex: 1,}}><span>{data.currentPrice}</span></TableCell>
                                                 <TableCell style={{textAlign: 'center'}}><span>{data.talentCricket}</span></TableCell>
                                                 <TableCell style={{textAlign: 'center'}}><span>{data.ozwat}</span></TableCell>
                                                 <TableCell style={{textAlign: 'center'}}><span>{data.allRoundCricket}</span></TableCell>
                                                 <TableCell style={{textAlign: 'center'}}><span>{data.romida}</span></TableCell>
                                                 <TableCell style={{textAlign: 'center'}}><span>{data.mrCricket}</span></TableCell>
                                                 <TableCell style={{textAlign: 'center'}}><span>{data.morant}</span></TableCell>
                                                 <TableCell style={{textAlign: 'center'}}><span>{data.serious}</span></TableCell>
                                                 <TableCell style={{textAlign: 'center'}}><span>{data.cricketHockey}</span></TableCell>

                                                {/* <TableCell><span>{data.cricketDirect}</span></TableCell> */}
                                                {/* <TableCell><span>{data.cricketDirect}</span></TableCell>
                                                <TableCell><span>{data.proDirect}</span></TableCell>
                                                
                                                <TableCell><span>{data.seriousCricket}</span></TableCell>
                                                
                                                <TableCell><span>{data.totalCricket}</span></TableCell> */}
                                                
                                                
                                                

                                            </TableRow>

                                        )
                                     
                                    })}
                                   
                                </TableBody>
                                
                            </Table>
                            </TableContainer>
                        </Paper>)}
                    </div>)}
                        

                    </div>

                </div>

            </div>
            {ExistingDeal()}
            {openConfirmModal &&((
            <ConfirmTopDealPrices 
            openModal={openConfirmModal} 
                
                topProducts={topProducts} 
                isSingleProdView={true} 
                selectedCategory={selectedCategory} 
                selectedModel={selectedModel}
                onClose={handleConfirmDealClose} 
                dateDetails={{startDate:startDate, endDate:endDate, showDate:isFirstView}}
                refreshData={handleRefreshData}
                isTopDealPreview={isTopDealPreview}
                isPriceSyncEnabled={isPriceSync}
            />
        ))}
        </div>
    )
    
    function ExistingDeal() {

        const isSmallScreen = useMediaQuery('(max-width:600px)');
        const updateCampaign = async (d) => {
            
            const res = await apiPost(UPDATECAMPAIGN, {
                
                id: d.id,
               
            });
            if (res) {
                AnalyticsService.logEvent("CAMPAIGN_UPDATED_SUCCESSFULLY");
                
                toast.success("Campaign updated successfully");
                await getCampaign();
            }
           
        };
        return (
            <Dialog style={{ display: 'flex', maxWidth: '100%', alignItems: 'center', justifyContent: 'center', overflowX: 'auto', overflowY: 'auto'}}
            open={open}  center onClose={onCloseModal}  maxWidth={isSmallScreen ? 'xs' : 'md'}>
           <DialogTitle><div className="bold lg space-bottom2 center">Your Existing Deals</div></DialogTitle>
           <DialogContent>
            <Paper className="padding space-top" sx={{ width: '100% !important', padding: '30px' }} maxWidth={false}>
                <div className="padding" style={{maxWidth: '100%'}}>
                    
                   
                        <div>

                        
                            {campaign?.map((data) => {
                                
                                    const startDate = data.startDate
                                    const endDate = data.endDate                       
                                return (
                                   
                                    <div className="space-bottom3" >
                                        <div className="space-bottom divLineUnder">
                                            <MarketingRow
                                            id={data.id}
                                            startDate = {startDate}
                                            endDate = {endDate}
                                            Category = {data.productCategory?.name}
                                            Model = {data.model?.name}
                                            Discount = {data.discount + "%"}
                                            name={data.name}
                                            TcsFuncded={data.isTcsFunded}
                                            updateCampaign={updateCampaign}
u
                                            />
                                        </div>
                                       
                                    </div>

                                )
                            })}
                        </div>
                        <div className="space-top" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <Button startIcon={isLoading && <BiLoaderCircle sx={{ color: "#8D0C18" }} />} onClick={() => setOpen(false)} style={{ backgroundColor: 'black', color: 'white' }} variant="contained">Close</Button>
                        </div>
                   
                </div>
                </Paper>
            </DialogContent> 
            
            </Dialog>
        )
    }
    
}

export default Marketing;